import React__default from 'react';
import { TypographyCore } from '../shared/components/Typography.mjs';

const Typography = (props)=>{
    const { disabled, ...rest } = props;
    return /*#__PURE__*/ React__default.createElement(TypographyCore, rest);
};

export { Typography };
//# sourceMappingURL=Typography.mjs.map
